<template>
    <div class="profile-card-header">
        <img :src="avatarUrl">
        <div class="profile-card-header-right">
            <div class="profile-card-header-right-top">
                <span class="color-grey">match rate </span>
                <div>
                    <span class="color-black">{{ score }}</span>
                    <span class="color-grey"> / 100</span>
                </div>
            </div>
            <div class="profile-card-header-availability">
                <span>{{ $trans('web_search.availability_status_types.' + availability) }}</span>
                <div class="availability-status" :class="availabilityClass"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        availability: {
            type: String,
            required: true,
        },
        avatarUrl: {
            type: String,
            required: true,
        },
        score: {
            type: Number,
            required: true,
        },
    },
    computed: {
        availabilityClass() {
            return {
                'border-availability-available': (this.availability == 'available'),
                'border-availability-on-request': (this.availability == 'on_request'),
                'border-availability-unavailable': (this.availability == 'unavailable')
            }
        }
    }
};
</script>

<style scoped>
.color-black { color: #000000; }
.color-grey { color: #747474; }

.profile-card-header {
    display: flex;
    gap: 10px;
}

.profile-card-header > img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    flex-shrink: 0;
}

.profile-card-header-right {
    flex-grow: 1;
}

.profile-card-header-right-top {
    text-align: right;
    padding-bottom: 8px;
    border-bottom: 1px solid #3C3C3C;
}

.profile-card-header-right-top > span {
    font-size: 20px;
}

.profile-card-header-right-top > div {
    font-size: 34px;
    display: inline;
}

.profile-card-header-availability {
    font-size: 20px;
    margin-top: 10px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: right;
}

.profile-card-header-availability span {
    margin-right: 10px;
}

.profile-card-header-availability .availability-status {
    width: 0;
    height: 0;
    border-radius: 50%;
    border-width: 12px;
    border-style: solid;
}

.border-availability-available { border-color: #41ABC4; }
.border-availability-on-request { border-color: #EF9630; }
.border-availability-unavailable { border-color: #FF6B65; }

@media (max-width: 768px) {
    .profile-card-header-right-top {
        font-size: 20px;
    }

    .color-grey {
        font-size: 18px;
    }

    .color-black {
        font-size: 18px;
    }

    .profile-card-header-availability {
        font-size: 14px;
    }
  }
</style>